import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { loaderContainer } from "./style";
import { useThemeContext } from "../../../globalContext/global-context";

const CommonLoader = () => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  return (
    <Box className="buttons-image-reponsive" sx={loaderContainer}>
      <CircularProgress
        size="1.5rem"
        sx={{ color: theme.tokens.color.action.primary }}
      />
    </Box>
  );
};

export default CommonLoader;
